import * as QuestionModule from 'Modules/QuestionModule';
import { Question } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Question.GET_SINGLE_QUESTION_INIT,
});

export const success = (data) => ({
  type: Question.GET_SINGLE_QUESTION_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Question.GET_SINGLE_QUESTION_FAILURE,
});

const qetQuestion = (uuid) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await QuestionModule.Connector.getSingleQuestion(uuid);
    dispatch(success(response.data.question));
    return true;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default qetQuestion;
